<template>
  <fieldset class="text-input">
    <div class="input-wrapper">
      <input
        v-if="!this.textarea"
        :id="_uid"
        v-model="currentValue"
        type="text"
        :class="classList"
      />
      <textarea
        rows="4"
        v-if="this.textarea"
        :id="_uid"
        v-model="currentValue"
        :class="classList"
      ></textarea>
      <label :for="_uid">{{ label }}</label>
    </div>

    <error-message :error="error"></error-message>
  </fieldset>
</template>

<script>
import ErrorMessage from '@/components/ErrorMessage'

export default {
  name: 'TextInput',

  components: {ErrorMessage},

  props: ['name', 'label', 'value', 'error', 'textarea', 'pattern'],

  computed: {
    currentValue: {
      get() {
        return this.value
      },

      set(newValue) {
        this.$emit('input', newValue)
      }
    },

    hasValue() {
      return !!this.currentValue
    },

    /**
     * component classList
     *
     * @returns {object} classnames object
     */
    classList() {
      return {
        'has-focus': this.hasFocus,
        'has-value': this.hasValue,
        'is-invalid': this.error
      }
    }
  }
}
</script>

<style lang="sass">
@import '../../../stylesheets/base/variables'
@import '../../../stylesheets/base/theme'

.input-wrapper
  position: relative
  background: #fff

.text-input
  border: none
  padding-bottom: 0
  margin: 5px 0
  padding: 10px 0

  label
    display: block
    text-align: left
    background: #fff
    padding: 2px
    border-radius: 3px
    border: 1px solid rgba(0, 0, 0, 0)
    position: absolute
    font-size: 16px
    bottom: 5px
    left: 10px
    transition: all .3s ease
    cursor: text
    pointer-events: none

    @include themify($themes)
      color: themed('color-body')

  textarea
    resize: none

  input, textarea
    font-size: 14px
    color: #000
    background: none
    border: none
    display: block
    padding: 10px
    width: 100%
    border-radius: 0

    &[type="text"]
      border-bottom: 1px solid rgba(0, 0, 0, 0.1)
      width: 100%
      padding: 10px

  input
    &:focus, &.has-value
      outline: none

      + label
        bottom: 32px
        font-size: 10px

  textarea
    &:focus, &.has-value
      outline: none

      + label
        bottom: -20px
        font-size: 10px
</style>
